<tab-header [workPackage]="workPackage"></tab-header>
<op-tab-prs [workPackage]="workPackage"></op-tab-prs>
